"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unfollow = exports.follow = exports.getFollowers = exports.getFollowing = void 0;
var redux_saga_routines_1 = require("redux-saga-routines");
exports.getFollowing = (0, redux_saga_routines_1.createRoutine)('following/GET_FOLLOWING');
exports.getFollowers = (0, redux_saga_routines_1.createRoutine)('following/GET_FOLLOWERS');
exports.follow = (0, redux_saga_routines_1.createRoutine)('following/FOLLOW');
exports.unfollow = (0, redux_saga_routines_1.createRoutine)('following/UNFOLLOW');
